import { useCallback } from "react";
import { useRecoilState } from "recoil";
import { HiX } from "react-icons/hi";
import { FaApple, FaGooglePlay } from "react-icons/fa";
import { Box } from "rebass/styled-components";

import { Modal } from "MVVM/Components/Wrappers/Existing/modal";
import { analytics } from "MVVM/Analytics";
import { ManageOnMobileModalState } from "MVVM/State";
import {
  ModalContainer,
  ModalHeader,
  HeaderTitle,
  HeaderSubtitle,
  CloseButton,
  ModalBody,
  InfoCard,
  InfoIconWrapper,
  InfoTextContent,
  InfoTitle,
  InfoDescription,
  ModalFooter,
  PrimaryButton,
  SecondaryButton,
} from "./styledComponents";

const STORE_CONFIG = {
  apple: {
    name: "App Store",
    Icon: FaApple,
    url: "https://apps.apple.com/account/subscriptions",
    instructions:
      "Open the App Store app on your iPhone or iPad, tap your profile, then Subscriptions to make changes.",
  },
  google: {
    name: "Google Play",
    Icon: FaGooglePlay,
    url: "https://play.google.com/store/account/subscriptions",
    instructions:
      "Open the Google Play Store app on your Android device, tap your profile, then Payments & subscriptions to make changes.",
  },
} as const;

export const ManageOnMobile = () => {
  const [{ isOpen, store }, setState] = useRecoilState(
    ManageOnMobileModalState,
  );

  const handleClose = useCallback(() => {
    setState({ isOpen: false, store: null });
  }, [setState]);

  const config = store ? STORE_CONFIG[store] : null;

  const handleOpenStore = useCallback(() => {
    if (!config) return;
    analytics.track("Manage Subscription Mobile Store Click", { store });
    window.open(config.url, "_blank", "noopener,noreferrer");
    handleClose();
  }, [config, store, handleClose]);

  if (!isOpen || !config) return null;

  const { name, Icon } = config;

  return (
    <Modal
      isModalOpen={isOpen}
      setModalOpen={(open: boolean) => !open && handleClose()}
      handleModalClose={undefined}
      disableOutsideClose={false}
    >
      <ModalContainer>
        <ModalHeader>
          <div>
            <HeaderTitle>Manage on {name}</HeaderTitle>
            <HeaderSubtitle>
              You subscribed through the {name}, so your subscription is managed
              there.
            </HeaderSubtitle>
          </div>
          <CloseButton onClick={handleClose}>
            <HiX size={20} />
          </CloseButton>
        </ModalHeader>

        <ModalBody>
          <InfoCard>
            <InfoIconWrapper>
              <Icon size={24} />
            </InfoIconWrapper>
            <InfoTextContent>
              <InfoTitle>Update or cancel on {name}</InfoTitle>
              <InfoDescription>{config.instructions}</InfoDescription>
            </InfoTextContent>
          </InfoCard>
        </ModalBody>

        <ModalFooter>
          <PrimaryButton onClick={handleOpenStore}>
            <Icon size={18} />
            <Box>Go to {name}</Box>
          </PrimaryButton>
          <SecondaryButton onClick={handleClose}>Close</SecondaryButton>
        </ModalFooter>
      </ModalContainer>
    </Modal>
  );
};
